// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"63bf27cc","164":"42ad8e41","276":"7d83da50","288":"a8c5da30","453":"ec61b04e","532":"cdb16252","672":"c90b3939","874":"adb9ca58","984":"7cab2079"}[chunkId] + ".chunk.js";
};